import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    rooms: {},
    activeRoom: null,
    order: [],
    error: null,
    loading: false,
    deletedLoading: false,
    setOwner: false
};

const getRoomsStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getDeletedRoomsStart = (state, action) => {
    return updateObject(state, { error: null, deletedLoading: true });
}

const getRoomsSuccess = (state, action) => {

    let newRooms = {};
    Object.keys(action.rooms).forEach(id => {
        let room = action.rooms[id];
        const { metadata, clips, ...pData } = room.data;
        newRooms[room.id] = { ...pData, metadata: metadata, originalObject: room, created: room.created, sysuser: room.sysuser || false };
    });

    return updateObject(state, {
        rooms: newRooms, loading: false, setOwner: true
    });
}

const getRoomsFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const getDeletedRoomsSuccess = (state, action) => {
    let newProjects = {};
    Object.keys(action.deletedRooms).forEach(id => {
        let project = action.deletedRooms[id];
        const { metadata, clips, ...pData } = project.data;
        newProjects[project.id] = { ...pData, metadata: metadata, originalObject: project, created: project.created, sysuser: project.sysuser || false };
    });

    return updateObject(state, {
        deletedRooms: newProjects, deletedLoading: false
    });
}

const setActiveRoom = (state, action) => {
    return updateObject(state, { activeRoom: action.payload.activeRoom });
}

const roomDeleted = (state, action) => {
	let delRooms = { ...state.deletedRooms }
    delete (delRooms[action.payload.roomId]);
    return updateObject(state, { deletedRooms: delRooms, deletedLoading: false });
}

const updateRoom = (state, action) => {
    let room = action.room;
    const { metadata, clips, ...pData } = room.data;
    let newRoom = { ...pData, metadata: metadata, originalObject: room, created: room.created, sysuser: room.sysuser || false };

    return updateObject(state, { rooms: updateObject(state.rooms, { [room.id]: newRoom }) });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ROOMS_START:
            return getRoomsStart(state, action);
        case actionTypes.GET_ROOMS_SUCCESS:
            return getRoomsSuccess(state, action);
        case actionTypes.GET_ROOMS_FAIL:
            return getRoomsFail(state, action);
        case actionTypes.GET_DELETED_ROOMS_START:
            return getDeletedRoomsStart(state, action);
        case actionTypes.GET_DELETED_ROOMS_SUCCESS:
            return getDeletedRoomsSuccess(state, action);
        case actionTypes.SET_ACTIVE_ROOM:
            return setActiveRoom(state, action);
		case actionTypes.DELETE_ROOM_START:
            return updateObject(state, { deletedLoading: true });
        case actionTypes.DELETE_ROOM_SUCCESS:
            return roomDeleted(state, action);
		case actionTypes.DELETE_ROOM_FAIL:
            return updateObject(state, { deletedLoading: false });
        case actionTypes.ROOM_UPDATE_RECEIVED:
            return updateRoom(state, action);
        default:
            return state;
    }
}

export default reducer;
